export default __webpack_public_path__ + "static/media/File No. 27.d4d1572f.pdf";